// Extracted from legacy src/components/templates.js

// Template Categories
export const TEMPLATE_CATEGORIES = {
  CLASSIC: 'Класически',
  MODERN: 'Модерни',
  MINIMAL: 'Минималистични',
  VIBRANT: 'Ярки'
};
